import type { ChangeObject } from 'diff';
import { marked, type Token } from 'marked';

type SlotMap = Map<string, string>;

const SLOT_REGEX = /<__SLOT__>(.*?)<\/__SLOT__>\n/g;
const buildSlot = (hash: string) => `<__SLOT__>${hash}</__SLOT__>\n`;

/**
 * 提取Markdown中的代码块
 * @param markdown Markdown文本
 * @returns 代码块数组
 */
export function replaceSlots(markdown: string): {
  slots: SlotMap;
  markdown: string;
} {
  const slotMap: SlotMap = new Map();

  const tokens = marked.lexer(markdown);
  tokens.forEach((item: Token) => {
    if (item.type === 'code' || item.type === 'table') {
      const hash = item.raw.replaceAll('\n', '');
      // 为了避免与普通文本中的 __SLOT_${hash}__ 冲突，在slot 两侧添加 _SLOT_ 前缀，用于后续匹配
      const key = buildSlot(hash);
      slotMap.set(key, item.raw);
      item.raw = key;
    }
  });

  const output = tokens.reduce((text: string, item: Token) => {
    text += item.raw;
    return text;
  }, '');

  return { slots: slotMap, markdown: output };
}

function matchSlot(line: string, slotMap: SlotMap): string | null {
  // 尝试从 line 中提取 __SLOT_${hash}__ 的部分进行匹配，规避某些情况下diffjs 可能更改原数据
  const matchs = line.matchAll(SLOT_REGEX).toArray();
  if (!matchs.length) {
    return null;
  }
  matchs.forEach(match => {
    try {
      const key = match?.length ? match[0] : line.trim();
      if (slotMap.has(key)) {
        const val = slotMap.get(key) || '';
        line = line.replace(key, val);
      }
    } catch (error) {
      // 处理掉错误
    }
  });
  return line;
}

export function restoreSlots(
  result: ChangeObject<string>[],
  slotMap: SlotMap
): ChangeObject<string>[] {
  result.forEach((part: any) => {
    // 遍历 diffResult 时候还原slot内容
    const val = matchSlot(part.value, slotMap);
    if (val !== null) {
      part.value = val;
      part.block = true;
    }
  });

  return result;
}
